export const validateName = async (rule,value) => {
    if(value && value.length < 2){
        throw new Error('Debe tener al menos 2 caracteres de longitud');
    }

    if(value && !(/^[a-zA-ZÑñáéíóúÁÉÍÓÚ\s.'-]+$/).test(value)){
        throw new Error('Debe contener solamente caracteres alfabeticos');
    }
}

export const validateCellPhone = async (rule,value) => {
    if(value && !(/^[0-9]{9}$/.test(value))){
        throw new Error('Debe contener un numero de 9 digitos');
    }
}

export const validateDni = async (rule,value) => {
    if(value && !(/^[0-9]{8}$/.test(value))){
        throw new Error('Debe contener un numero de 8 digitos');
    }
}

export const validateInstagram = async (rule,value) => {
    if(value && !(/^[a-zA-Z0-9._]{1,30}$/.test(value))){
        throw new Error('Ingrese una cuenta valida de instagram');
    }
}

export const validateModelSKU = async (rule,value) => {
    if(value && !(/^(?=.*[A-Z])(?=.*\d)[^\s]+$/.test(value))){
        throw new Error('Debe tener caracteres alfanumericos en mayuscula');
    }
}

export const validateAddress = async (rule,value) => {
    if(value && value.length < 5){
        throw new Error('Debe tener almenos 5 caracteres de longitud');
    }
}

export const validateSize = async (rule,value) => {
    if(value && !( value > 1 && value < 60)){
        throw new Error('Debe ser un numero entre 2 y 60');
    }
}

export const validateColor = async (rule,value) => {
    if(value && !(/^[a-zA-Z\s]+$/.test(value))){
        throw new Error('Solamente caracteres alfabeticos');
    }
}

export const validateQty = async (rule,value) => {
    if(value && !(/^[0-9]+$/.test(value))){
        throw new Error('Solamente se aceptan numeros enteros');
    }
}

export const validatePrice = async (rule,value) => {
    if(value && !(/^\d+(?:\.\d{1,2})?$/.test(value))){
        throw new Error('Entrar un precio con maximo dos decimales');
    }
}

export const validateObservation = async (rule,value) => {
    if(value && (value.length < 5 || value.length > 300)){
        throw new Error('Debe tener una longitud de minima de 5 caracteres');
    }
}

export const validateCode = async (rule,value) => {
    if(value && (value.length > 15)){
        throw new Error('Debe tener una longitud maxima de 15 caracteres');
    }
    if(value && !(/^[a-zA-Z0-9]+$/.test(value))){
        throw new Error('Solamente caracteres alfanumericos');
    }
}